(()=>{
  const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const readerViewport=window.matchMedia('(max-width: 989px)');

  const structureRichPanels=root=>{
    ['benefits','suit','appointment','aftercare'].forEach(key=>{
      const bodies=[...root.querySelectorAll(`[data-hxtp-panel="${key}"] .hxtp-panel__body, [data-hxtp-reader-panel="${key}"] .hxtp-panel__body`)];

      bodies.forEach(body=>{
        if(!body||body.dataset.hxtpStructured==='true')return;

        const children=[...body.children];
        const firstHeading=children.findIndex(node=>node.tagName==='H3');
        const headingCount=children.filter(node=>node.tagName==='H3').length;

        if(firstHeading<0||headingCount<2){
          body.dataset.hxtpStructured='true';
          return;
        }

        const before=children.slice(0,firstHeading);
        const wrapper=document.createElement('div');
        wrapper.className='hxtp-rich-items';
        let item=null;

        children.slice(firstHeading).forEach(node=>{
          if(node.tagName==='H3'){
            item=document.createElement('section');
            item.className='hxtp-rich-item';
            wrapper.appendChild(item);
          }
          if(item)item.appendChild(node);
        });

        body.replaceChildren(...before,wrapper);
        body.classList.add('has-rich-items');
        body.dataset.hxtpStructured='true';
      });
    });
  };

  const init=root=>{
    if(root.dataset.hxtpProductReady)return;
    root.dataset.hxtpProductReady='true';
    structureRichPanels(root);

    const exploreLabel=root.dataset.exploreLabel||'Explore This Treatment';
    const readerContextLabel=root.dataset.readerContextLabel||'treatment';
    const panels=[...root.querySelectorAll('[data-hxtp-panel]')];
    const navButtons=[...root.querySelectorAll('[data-hxtp-nav-target]')];
    const openButton=root.querySelector('[data-hxtp-explore-open]');

    const reader=root.querySelector('[data-hxtp-reader]');
    const readerClose=root.querySelector('[data-hxtp-explore-close]');
    const readerMenu=root.querySelector('[data-hxtp-reader-menu]');
    const readerStage=root.querySelector('[data-hxtp-reader-stage]');
    const readerIndex=root.querySelector('[data-hxtp-reader-index]');
    const readerPanels=reader?[...reader.querySelectorAll('[data-hxtp-reader-panel]')]:[];
    const readerTargets=reader?[...reader.querySelectorAll('[data-hxtp-reader-target]')]:[];
    const readerTitle=reader?.querySelector('[data-hxtp-reader-title]');
    const readerProgress=reader?.querySelector('[data-hxtp-reader-progress]');
    const readerProgressIcon=reader?.querySelector('[data-hxtp-reader-progress-icon]');
    const readerPrev=reader?.querySelector('[data-hxtp-reader-prev]');
    const readerNext=reader?.querySelector('[data-hxtp-reader-next]');
    const readerPrevLabel=reader?.querySelector('[data-hxtp-reader-prev-label]');
    const readerNextLabel=reader?.querySelector('[data-hxtp-reader-next-label]');
    const readerSwipeHint=reader?.querySelector('.hxtp-reader__swipe-hint > span:last-child');
    const readerFinal=reader?.querySelector('[data-hxtp-reader-final]');

    let active=root.dataset.firstPanel||panels[0]?.dataset.hxtpPanel||readerPanels[0]?.dataset.hxtpReaderPanel||'';
    let readerKey=active||readerPanels[0]?.dataset.hxtpReaderPanel||'';
    let touchStart=null;

    const panelFor=key=>panels.find(panel=>panel.dataset.hxtpPanel===key);
    const readerPanelFor=key=>readerPanels.find(panel=>panel.dataset.hxtpReaderPanel===key);
    const readerIndexFor=key=>readerPanels.findIndex(panel=>panel.dataset.hxtpReaderPanel===key);
    const readerLabel=panel=>panel?.dataset.hxtpReaderLabel||'';

    const updateButtons=key=>{
      navButtons.forEach(button=>{
        const selected=Boolean(key)&&button.dataset.hxtpNavTarget===key;
        button.classList.toggle('is-active',selected);
        if(selected){
          button.setAttribute('aria-current','true');
        }else{
          button.removeAttribute('aria-current');
        }
      });
    };

    const updateReaderTargets=key=>{
      readerTargets.forEach(button=>{
        const selected=Boolean(key)&&button.dataset.hxtpReaderTarget===key;
        button.classList.toggle('is-active',selected);
        if(selected){
          button.setAttribute('aria-current','true');
        }else{
          button.removeAttribute('aria-current');
        }
      });
    };

    const setPanelState=(panel,open)=>{
      const trigger=panel.querySelector('[data-hxtp-accordion-trigger]');
      const content=panel.querySelector('[data-hxtp-accordion-content]');
      panel.classList.toggle('is-open',open);
      trigger?.setAttribute('aria-expanded',String(open));
      if(content)content.hidden=!open;
    };

    const updateHash=key=>{
      if(!history.replaceState||!key)return;
      const url=new URL(location.href);
      url.hash=`treatment-${key}`;
      history.replaceState(null,'',url);
    };

    const clearHash=key=>{
      if(!history.replaceState||location.hash!==`#treatment-${key}`)return;
      const url=new URL(location.href);
      url.hash='';
      history.replaceState(null,'',url.pathname+url.search);
    };

    const scrollToPanel=panel=>{
      requestAnimationFrame(()=>{
        panel.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
      });
    };

    const openPanel=(key,{scroll=false,hash=true}={})=>{
      const target=panelFor(key);
      if(!target)return;
      panels.forEach(panel=>setPanelState(panel,panel===target));
      active=key;
      if(readerPanelFor(key))readerKey=key;
      updateButtons(key);
      if(hash)updateHash(key);
      if(scroll)scrollToPanel(target);
    };

    const collapsePanel=key=>{
      const target=panelFor(key);
      if(!target||!target.classList.contains('is-open'))return;
      setPanelState(target,false);
      if(active===key){
        active='';
        updateButtons('');
      }
      clearHash(key);
    };

    const updateReaderChrome=key=>{
      if(!readerPanels.length)return;
      const index=readerIndexFor(key);
      if(index<0)return;

      const total=readerPanels.length;
      if(readerProgress)readerProgress.textContent=`${String(index+1).padStart(2,'0')} / ${String(total).padStart(2,'0')}`;

      if(readerProgressIcon){
        const sourceIcon=readerTargets.find(button=>button.dataset.hxtpReaderTarget===key)?.querySelector('svg');
        readerProgressIcon.replaceChildren();
        if(sourceIcon)readerProgressIcon.appendChild(sourceIcon.cloneNode(true));
      }

      const previous=readerPanels[index-1];
      const next=readerPanels[index+1];
      if(readerSwipeHint){
        const nextTitle=next?readerLabel(next):exploreLabel;
        readerSwipeHint.textContent=`Swipe: ${nextTitle}`;
      }

      if(readerPrev){
        readerPrev.hidden=false;
        const label=previous?readerLabel(previous):'Explore menu';
        if(readerPrevLabel)readerPrevLabel.textContent=label;
        readerPrev.setAttribute('aria-label',previous?`Previous: ${label}`:'Back to Explore menu');
        readerPrev.dataset.hxtpReaderEdge=previous?'chapter':'menu';
      }
      if(readerNext){
        readerNext.hidden=false;
        const label=next?readerLabel(next):'Explore menu';
        if(readerNextLabel)readerNextLabel.textContent=label;
        readerNext.setAttribute('aria-label',next?`Next: ${label}`:'Open Explore menu');
        readerNext.dataset.hxtpReaderEdge=next?'chapter':'menu';
      }
      if(readerFinal)readerFinal.hidden=index!==total-1;
      updateReaderTargets(key);
    };

    const showReaderPanel=(key,{direction='none',focus=false,sync=true,hash=true}={})=>{
      const target=readerPanelFor(key);
      if(!target)return false;

      readerPanels.forEach(panel=>{
        panel.hidden=panel!==target;
        if(panel!==target)panel.classList.remove('is-entering-next','is-entering-prev');
      });

      readerKey=key;
      if(sync&&panelFor(key))openPanel(key,{scroll:false,hash});
      updateReaderChrome(key);

      if(readerStage){
        readerStage.scrollTo({top:0,left:0,behavior:'auto'});
      }

      if(!reduced()&&direction!=='none'){
        const className=direction==='prev'?'is-entering-prev':'is-entering-next';
        target.classList.remove('is-entering-next','is-entering-prev');
        void target.offsetWidth;
        target.classList.add(className);
        window.setTimeout(()=>target.classList.remove(className),260);
      }

      if(focus){
        requestAnimationFrame(()=>target.querySelector('h2')?.focus({preventScroll:true}));
      }
      return true;
    };

    const setReaderIndex=(open,{focus=true}={})=>{
      if(!readerStage||!readerIndex||!readerMenu)return;
      readerStage.hidden=open;
      readerIndex.hidden=!open;
      reader.classList.toggle('is-index',open);
      reader.classList.toggle('is-stage',!open);
      readerMenu.hidden=open;
      readerMenu.classList.toggle('is-active',open);
      readerMenu.setAttribute('aria-expanded',String(open));
      readerMenu.setAttribute('aria-label',open?`Close ${readerContextLabel} section menu`:`Open ${readerContextLabel} section menu`);
      if(readerTitle)readerTitle.textContent=open?exploreLabel:readerTitle.dataset.productTitle;

      if(!focus)return;
      requestAnimationFrame(()=>{
        if(open){
          const current=readerIndex.querySelector(`[data-hxtp-reader-target="${CSS.escape(readerKey)}"]`);
          (current||readerTargets[0])?.focus();
        }else{
          readerMenu.focus();
        }
      });
    };

    const closeReader=restore=>{
      if(!reader?.open)return;
      reader.close();
      document.body.classList.remove('hxtp-reader-open');
      setReaderIndex(false,{focus:false});
      if(restore)openButton?.focus();
    };

    const openReader=()=>{
      if(!reader||!readerPanels.length)return;
      if(active&&readerPanelFor(active))readerKey=active;
      if(!readerPanelFor(readerKey))readerKey=readerPanels[0].dataset.hxtpReaderPanel;
      showReaderPanel(readerKey,{sync:false,hash:false});
      setReaderIndex(true,{focus:false});
      document.body.classList.add('hxtp-reader-open');
      reader.showModal();
      requestAnimationFrame(()=>{
        const current=readerIndex?.querySelector(`[data-hxtp-reader-target="${CSS.escape(readerKey)}"]`);
        (current||readerTargets[0]||readerClose)?.focus();
      });
    };

    const moveReader=(direction,{focusMenu=false}={})=>{
      const currentIndex=readerIndexFor(readerKey);
      if(currentIndex<0)return;
      const nextIndex=direction==='prev'?currentIndex-1:currentIndex+1;
      const target=readerPanels[nextIndex];

      if(!target){
        setReaderIndex(true,{focus:focusMenu});
        return;
      }

      showReaderPanel(target.dataset.hxtpReaderPanel,{direction,sync:true,hash:true});
    };

    openButton?.addEventListener('click',openReader);
    readerClose?.addEventListener('click',()=>closeReader(true));

    readerMenu?.addEventListener('click',()=>{
      if(!readerIndex||!readerStage)return;
      setReaderIndex(readerIndex.hidden,{focus:true});
    });

    reader?.addEventListener('cancel',event=>{
      event.preventDefault();
      closeReader(true);
    });

    reader?.addEventListener('close',()=>{
      document.body.classList.remove('hxtp-reader-open');
    });

    readerTargets.forEach(button=>{
      button.addEventListener('click',()=>{
        const key=button.dataset.hxtpReaderTarget;
        setReaderIndex(false,{focus:false});
        showReaderPanel(key,{direction:'none',focus:true,sync:true,hash:true});
      });
    });

    readerPrev?.addEventListener('click',()=>moveReader('prev',{focusMenu:true}));
    readerNext?.addEventListener('click',()=>moveReader('next',{focusMenu:true}));

    if(readerStage){
      let suppressSwipeClickUntil=0;
      let suppressSwipeClickTarget=null;
      const swipeInteractiveTarget=target=>target instanceof Element?target.closest('a,button,summary,[role="button"]'):null;
      const blocksSwipe=target=>target instanceof Element&&Boolean(target.closest('input,select,textarea,label'));
      const startSwipe=(x,y,time=Date.now(),pointerId=null,target=null)=>{
        const edge=20;
        if(x<=edge||x>=window.innerWidth-edge)return;
        touchStart={x,y,time,pointerId,interactive:swipeInteractiveTarget(target)};
      };
      const finishSwipe=(x,y,time=Date.now(),pointerId=null)=>{
        if(!touchStart)return;
        if(touchStart.pointerId!==null&&pointerId!==null&&touchStart.pointerId!==pointerId)return;
        const start=touchStart;
        const dx=x-start.x;
        const dy=y-start.y;
        const elapsed=time-start.time;
        touchStart=null;
        if(elapsed>1000||Math.abs(dx)<48||Math.abs(dx)<=Math.abs(dy)*1.15)return;
        if(start.interactive){
          suppressSwipeClickTarget=start.interactive;
          suppressSwipeClickUntil=Date.now()+450;
        }
        moveReader(dx<0?'next':'prev',{focusMenu:false});
      };

      readerStage.addEventListener('click',event=>{
        const interactive=swipeInteractiveTarget(event.target);
        if(Date.now()>suppressSwipeClickUntil||!interactive||interactive!==suppressSwipeClickTarget)return;
        event.preventDefault();
        event.stopPropagation();
        suppressSwipeClickUntil=0;
        suppressSwipeClickTarget=null;
      },true);

      if(window.PointerEvent){
        readerStage.addEventListener('pointerdown',event=>{
          if(!readerIndex?.hidden||blocksSwipe(event.target))return;
          if(event.pointerType==='mouse'&&event.button!==0)return;
          startSwipe(event.clientX,event.clientY,Date.now(),event.pointerId,event.target);
        },{passive:true});
        readerStage.addEventListener('pointerup',event=>finishSwipe(event.clientX,event.clientY,Date.now(),event.pointerId),{passive:true});
        readerStage.addEventListener('pointercancel',()=>{touchStart=null;},{passive:true});
      }else{
        readerStage.addEventListener('touchstart',event=>{
          if(!readerIndex?.hidden||event.touches.length!==1||blocksSwipe(event.target))return;
          const touch=event.touches[0];
          startSwipe(touch.clientX,touch.clientY,Date.now(),null,event.target);
        },{passive:true});
        readerStage.addEventListener('touchend',event=>{
          if(event.changedTouches.length!==1){touchStart=null;return;}
          const touch=event.changedTouches[0];
          finishSwipe(touch.clientX,touch.clientY);
        },{passive:true});
        readerStage.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});
      }
    }

    reader?.querySelectorAll('[data-hxtp-reader-book]').forEach(link=>{
      link.addEventListener('click',event=>{
        const target=root.querySelector('#hxtp-booking');
        if(!target)return;
        event.preventDefault();
        closeReader(false);
        requestAnimationFrame(()=>target.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'}));
      });
    });

    navButtons.forEach(button=>{
      button.addEventListener('click',()=>{
        const key=button.dataset.hxtpNavTarget;
        openPanel(key,{scroll:true});
      });
    });

    panels.forEach(panel=>{
      const key=panel.dataset.hxtpPanel;
      const trigger=panel.querySelector('[data-hxtp-accordion-trigger]');
      trigger?.addEventListener('click',()=>{
        if(panel.classList.contains('is-open')){
          collapsePanel(key);
        }else{
          openPanel(key);
        }
      });
    });

    // Keep each FAQ group calm and compact: only one answer can be open at a time.
    root.querySelectorAll('.hxtp-faqs').forEach(group=>{
      const details=[...group.querySelectorAll('details')];
      details.forEach(detail=>{
        detail.addEventListener('toggle',()=>{
          if(!detail.open)return;
          details.forEach(other=>{
            if(other!==detail&&other.open)other.open=false;
          });
        });
      });
    });

    const hashMatch=location.hash.match(/^#treatment-(.+)$/);
    const hashKey=hashMatch?.[1]||'';
    if(hashKey&&panelFor(hashKey)){
      openPanel(hashKey,{scroll:!readerViewport.matches,hash:false});
      if(readerPanelFor(hashKey)){
        readerKey=hashKey;
        showReaderPanel(hashKey,{sync:false,hash:false});
      }
    }else if(active&&panelFor(active)){
      openPanel(active,{hash:false});
      if(readerPanelFor(active))showReaderPanel(active,{sync:false,hash:false});
    }else if(readerPanels.length){
      readerKey=readerPanels[0].dataset.hxtpReaderPanel;
      showReaderPanel(readerKey,{sync:false,hash:false});
    }

    root.querySelectorAll('a[href="#hxtp-booking"]:not([data-hxtp-reader-book])').forEach(link=>{
      link.addEventListener('click',event=>{
        const target=root.querySelector('#hxtp-booking');
        if(!target)return;
        event.preventDefault();
        target.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
      });
    });

    const onReaderViewportChange=event=>{
      if(!event.matches&&reader?.open)closeReader(false);
    };
    if(readerViewport.addEventListener){
      readerViewport.addEventListener('change',onReaderViewportChange);
    }else if(readerViewport.addListener){
      readerViewport.addListener(onReaderViewportChange);
    }

    const gallery=root.querySelector('[data-hxtp-gallery]');
    if(gallery){
      const track=gallery.querySelector('[data-hxtp-gallery-track]');
      const slides=[...gallery.querySelectorAll('[data-hxtp-gallery-slide]')];
      const count=gallery.querySelector('[data-hxtp-gallery-count]');
      const prev=gallery.querySelector('[data-hxtp-gallery-prev]');
      const next=gallery.querySelector('[data-hxtp-gallery-next]');
      let index=0;

      const render=()=>{
        if(!slides.length)return;
        let nearest=0;
        let distance=Infinity;
        slides.forEach((slide,i)=>{
          const delta=Math.abs(slide.offsetLeft-track.scrollLeft);
          if(delta<distance){
            distance=delta;
            nearest=i;
          }
        });
        index=nearest;
        if(count)count.textContent=`${index+1} / ${slides.length}`;
        if(prev)prev.disabled=index===0;
        if(next)next.disabled=index===slides.length-1;
      };

      const go=i=>{
        const target=slides[Math.max(0,Math.min(slides.length-1,i))];
        target?.scrollIntoView({behavior:reduced()?'auto':'smooth',inline:'start',block:'nearest'});
      };

      prev?.addEventListener('click',()=>go(index-1));
      next?.addEventListener('click',()=>go(index+1));

      let ticking=false;
      track?.addEventListener('scroll',()=>{
        if(ticking)return;
        ticking=true;
        requestAnimationFrame(()=>{
          render();
          ticking=false;
        });
      },{passive:true});

      let dragging=false;
      let startX=0;
      let startScroll=0;

      track?.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse')return;
        dragging=true;
        startX=event.clientX;
        startScroll=track.scrollLeft;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });

      track?.addEventListener('pointermove',event=>{
        if(dragging)track.scrollLeft=startScroll-(event.clientX-startX);
      });

      const stop=event=>{
        if(!dragging)return;
        dragging=false;
        track.classList.remove('is-dragging');
        try{track.releasePointerCapture(event.pointerId)}catch(e){}
      };

      track?.addEventListener('pointerup',stop);
      track?.addEventListener('pointercancel',stop);
      slides.forEach(slide=>slide.querySelectorAll('img').forEach(img=>img.draggable=false));
      render();
    }
  };

  const run=()=>document.querySelectorAll('[data-hxtp-root]').forEach(init);

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  document.addEventListener('shopify:section:load',run);
})();
